module.exports = "<div class=Button-group><component v-for=\"field in fdata.content\" :is=field.type :fdata.sync=field></component></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/buttons/group.vue
// module id = 436
// module chunks = 0